import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f675dab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StepSenders" }
const _hoisted_2 = {
  key: 1,
  class: "px-6 py-4 bg-white border"
}
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "StepSenders__title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "StepSenders__state mt-2"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "state__message message--failed" }, " Произошла ошибка при загрузке списка отправителей ", -1))
const _hoisted_8 = {
  key: 1,
  class: "StepSenders__list"
}
const _hoisted_9 = {
  key: 0,
  class: "StepSenders__state mt-2"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "state__message" }, "Список пуст", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "text-gray-400 font-semibold text-sm mt-3 select-none"
}
const _hoisted_13 = { class: "ml-2" }
const _hoisted_14 = {
  class: "list__wrapper",
  ref: "templatewindow"
}
const _hoisted_15 = {
  key: 2,
  class: "StepSenders__state mt-2"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "state__message" }, "Загрузка списка отправителей...", -1))
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "px-6 py-4 bg-white border" }
const _hoisted_19 = { class: "flex items-center justify-between" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "StepSenders__title" }, "Отправитель", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_22 = { class: "StepSenders__sender mt-2" }
const _hoisted_23 = { class: "sender__title" }
const _hoisted_24 = { class: "mt-2 text-sm" }
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-user mr-2" }, null, -1))
const _hoisted_27 = { class: "block" }
const _hoisted_28 = { class: "flex items-center mt-1" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-mobile mr-3" }, null, -1))
const _hoisted_30 = { class: "block" }
const _hoisted_31 = { class: "flex items-center mt-1" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-map-marker-alt mr-3" }, null, -1))
const _hoisted_33 = { class: "block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_templates_spark_actions = _resolveComponent("templates-spark-actions")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_senders_spark_list_item = _resolveComponent("senders-spark-list-item")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_templates_spark_actions, {
          key: 0,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "initial-value": _ctx.actions_state.initial_value,
          loading: _ctx.actions_state.is_actions_loading,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onCreate: _ctx.onSenderCreate,
          onUpdate: _ctx.onSenderUpdate
        }, null, 8, ["is-create", "is-update", "initial-value", "loading", "onCreate", "onUpdate"]))
      : _createCommentVNode("", true),
    (!_ctx.state.sender)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.stepNumber) + ". Выберите отправителя", 1),
            (_ctx.opened)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 0,
                  class: "primary small text",
                  disabled: _ctx.disabled,
                  onClick: _ctx.startCreate
                }, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _createTextVNode(" Новый отправной пункт ")
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.opened)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.data_state.senders.is_failed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _createVNode(_component_the_button, {
                        class: "primary small mt-2",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadSenders(_ctx.data_state.senders.pagination.current_page)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Обновить ")
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_the_input, {
                        value: _ctx.state.search,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.search) = $event)),
                        disabled: _ctx.disabled,
                        placeholder: "Поиск по номеру телефона, адресу и названию",
                        class: "mt-2 w-full",
                        onInput: _ctx.searchSender
                      }, null, 8, ["value", "disabled", "onInput"]),
                      (
                            !_ctx.data_state.senders.is_loading && _ctx.data_state.senders.list.length === 0
                        )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                        : _createCommentVNode("", true),
                      (!_ctx.data_state.senders.is_loading && _ctx.data_state.senders.list.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("span", null, "Страница: " + _toDisplayString(_ctx.data_state.senders.pagination.current_page), 1),
                            _createElementVNode("span", _hoisted_13, "Отправителей: " + _toDisplayString(_ctx.data_state.senders.list.length), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data_state.senders.list, (sender) => {
                          return (_openBlock(), _createBlock(_component_senders_spark_list_item, {
                            class: "StepSenders__item",
                            key: sender,
                            item: sender,
                            disabled: _ctx.disabled,
                            onSubmit: _ctx.onSenderSelect,
                            onUpdate: _ctx.startUpdate,
                            onDeleted: _ctx.onSenderDeleted
                          }, null, 8, ["item", "disabled", "onSubmit", "onUpdate", "onDeleted"]))
                        }), 128))
                      ], 512)
                    ])),
                (_ctx.data_state.senders.is_loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_loader, { class: "primary" }),
                      _hoisted_16
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_the_button, {
                class: "second small text",
                disabled: _ctx.disabled,
                onClick: _ctx.emitReset
              }, {
                default: _withCtx(() => [
                  _hoisted_21,
                  _createTextVNode(" Сбросить ")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.state.sender.fullName), 1),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.state.sender.user.fullName || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.state.sender.phoneNumber || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.state.sender.fullAddress || '-'), 1)
                ])
              ])
            ])
          ])
        ]))
  ]))
}